﻿/*
 * Globalize Culture tr-TR
 *
 * http://github.com/jquery/globalize
 *
 * Copyright Software Freedom Conservancy, Inc.
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * This file was generated by the Globalize Culture Generator
 * Translation: bugs found in this file need to be fixed in the generator
 */

(function(window, undefined) {
  var Globalize;

  if (
    typeof require !== "undefined" &&
    typeof exports !== "undefined" &&
    typeof module !== "undefined"
  ) {
    // Assume CommonJS
    Globalize = require("globalize");
  } else {
    // Global variable
    Globalize = window.Globalize;
  }

  Globalize.addCultureInfo("tr-TR", "default", {
    name: "tr-TR",
    englishName: "Turkish (Turkey)",
    nativeName: "Türkçe (Türkiye)",
    language: "tr",
    numberFormat: {
      ",": ".",
      ".": ",",
      percent: {
        pattern: ["-%n", "%n"],
        ",": ".",
        ".": ","
      },
      currency: {
        pattern: ["-n $", "n $"],
        ",": ".",
        ".": ",",
        symbol: "TL"
      }
    },
    calendars: {
      standard: {
        "/": ".",
        firstDay: 1,
        days: {
          names: [
            "Pazar",
            "Pazartesi",
            "Salı",
            "Çarşamba",
            "Perşembe",
            "Cuma",
            "Cumartesi"
          ],
          namesAbbr: ["Paz", "Pzt", "Sal", "Çar", "Per", "Cum", "Cmt"],
          namesShort: ["Pz", "Pt", "Sa", "Ça", "Pe", "Cu", "Ct"]
        },
        months: {
          names: [
            "Ocak",
            "Şubat",
            "Mart",
            "Nisan",
            "Mayıs",
            "Haziran",
            "Temmuz",
            "Ağustos",
            "Eylül",
            "Ekim",
            "Kasım",
            "Aralık",
            ""
          ],
          namesAbbr: [
            "Oca",
            "Şub",
            "Mar",
            "Nis",
            "May",
            "Haz",
            "Tem",
            "Ağu",
            "Eyl",
            "Eki",
            "Kas",
            "Ara",
            ""
          ]
        },
        AM: null,
        PM: null,
        patterns: {
          d: "dd.MM.yyyy",
          D: "dd MMMM yyyy dddd",
          t: "HH:mm",
          T: "HH:mm:ss",
          f: "dd MMMM yyyy dddd HH:mm",
          F: "dd MMMM yyyy dddd HH:mm:ss",
          M: "dd MMMM",
          Y: "MMMM yyyy"
        }
      }
    },
    messages: {
      AdditionalHelp: "Ek Yardım",
      AddNewTab: "Yeni Sekme Ekle",
      Alerts: "Uyarılar",
      ApplyFilter: "Filtre Uygula",
      Approve: "Onayla",
      Attachments: "Eklentiler",
      Back: "Geri",
      Basic: "Temel",
      Between: "Arasında",
      Book: "Kitap",
      Cancel: "İptal",
      Checked: "Kontrol Edildi",
      ClearFilter: "Filtreyi Temizle",
      Close: "Kapat",
      CloseCancelChanges: "Kapat ve Değişiklikleri İptal Et",
      CloseSaveChanges: "Kapat ve Değişiklikleri Kaydet",
      CloseTab: "Sekmeyi Kapat",
      ColumnPersonalization: "Sütun Kişiselleştirme",
      Comments: "Yorumlar",
      Confirmation: "Onay",
      Contains: "Şunu İçerir",
      CreateTab: "Yeni bir Sekme Oluştur",
      Cut: "Kes",
      Delete: "Sil",
      DiscardUndo: "Vazgeç/Geri Al",
      DisplayDropDownList: "Açılır listeyi göster",
      Displaying: "Gösterilen: ",
      DocWord: "Belge",
      DoesNotContain: "Şunu İçermez",
      DoesNotEndWith: "Şununla Bitmez",
      DoesNotEqual: "Şuna Eşit Değil",
      DoesNotStartWith: "Şununla başlamaz",
      Download: "İndir",
      Duplicate: "Yinelenen",
      Edit: "Düzenle",
      EitherSelectedorNotSelected: "Seçili veya Seçili Değil",
      Email: "E-posta",
      EndsWith: "Şununla Biter",
      EqualsStr: "Şuna Eşit",
      ExpandCollapse: "Genişlet/Daralt",
      ExportFailed: "Dışarı Aktarma Başarısız",
      ExportToExcel: "Excel\u0027e Aktar",
      FileInUse: "Belirtilen Dosya Kullanımda",
      FileInUseDetail:
        "Dosyanın kullanımda olduğu uygulamayı kapatın veya farklı bir dosya adı belirtin.",
      Filter: "Filtrele",
      FilterMenu: "Filtreleme Menüsü",
      FilterOptions: "Filtreleme Seçenekleri",
      FilterWithinResults: "Sonuçlarda Filtrele",
      First: "Birinci",
      FirstView: "Birinci Görünüm",
      Folder: "Klasör",
      ForgotPassword: "Parolanızı mı Unuttunuz?",
      Forward: "İleri",
      GetMoreRows: "Daha Fazla Satır Al",
      GreaterThan: "Şundan Daha Fazla",
      GreaterThanOrEquals: "Şundan Daha Fazla veya Eşit",
      GridSettings: "Kılavuz Ayarları",
      GroupSelection: "Grup Seçimi",
      Help: "Yardım",
      HideColumn: "Sütunu Gizle",
      IsEmpty: "Boş",
      IsNotEmpty: "Boş Değil",
      Last: "Son",
      LastView: "Son Görünüm",
      LaunchActivate: "Başlat/Etkinleştir",
      LessThan: "Şundan Daha Az",
      LessThanOrEquals: "Şundan Daha Az veya Eşit",
      Links: "Bağlantılar",
      ListTabs: "Tüm Sekmeleri Listele",
      LoadingItem: "Öğe yükleniyor ",
      Maintenance: "Bakım",
      Menu: "Menü",
      New: "Yeni ",
      Next: "Sonraki",
      NextView: "Sonraki Görünüm",
      No: "Hayır",
      NotChecked: "Kontrol Edilmedi",
      Notes: "Notlar",
      NotSelected: "Seçilmedi",
      Of: " / ",
      Ok: "Tamam",
      Open: "Aç",
      Password: "Parola",
      Paste: "Yapıştır",
      Phone: "Telefon",
      PleaseWait: "Lütfen Bekleyin",
      Previous: "Önceki",
      PreviousView: "Önceki Görünüm",
      Print: "Yazdır ",
      Queries: "Sorgular",
      Redo: "Yinele",
      Refresh: "Yenile",
      Reject: "Reddet",
      RememberMe: "Bu bilgisayarda beni hatırla",
      Reports: "Raporlar",
      Reset: "Sıfırla",
      Review: "Gözden Geçir",
      RunFilter: "Filtreyi Çalıştır",
      RunJob: "İşi Çalıştır",
      Save: "Kaydet",
      SaveBeforeClosing: "Kapatmadan Önce Kaydet",
      SavedFilters: "Kaydedilen Filtreler",
      SaveSubmit: "Kaydet/Gönder",
      ScreenDesign: "Ekran Tasarımı",
      Search: "Ara",
      SelectContents: "İçeriği Seç",
      SelectDate: "Bir Tarih Seç",
      SelectDeselect: "Hepsini Seç / Seçimini Kaldır",
      Selected: "Seçilenler: ",
      ServerName: "Sunucu Adı",
      Settings: "Ayarlar",
      ShowFilterRow: "Filtre Satırını Göster",
      SignIn: "Oturum Aç",
      SortAscending: "Artan Şekilde Sırala",
      SortDescending: "Azalan Şekilde Sırala",
      Spreadsheet: "Elektronik tablo",
      StartsWith: "Şununla biter",
      StatusIndicator: "Durum Göstergesi",
      Tasks: "Görevler",
      Today: "Bugün",
      Translate: "Çevir",
      UserID: "Kullanıcı kimliği",
      Utilities: "Yardımcı uygulamalar",
      Yes: "Evet",
      Page: "Sayfa",
      Rows: "Satırlar",
      ShowingAll: "Hepsi Gösteriliyor",
      SessionNavigation: "Oturum Gezintisi",
      ListAllMenuItems: "Tüm Menü Öğeleri Gösteriliyor",
      NoRecordsFound: "Kayıt Bulunmadı",
      SearchTree: "Arama Ağacı",
      Clear: "Temizle",
      DrillDown: "Detaya Git",
      Required: "Bu alan gerekli",
      Available: "Kullanılabilir:",
      Add: "Ekle",
      MoveDown: "Aşağı Taşı",
      MoveUp: "Yukarı Taşı",
      Remove: "Kaldır",
      LastYear: "Geçen Yıl",
      NextMonth: "Sonraki Ay",
      NextWeek: "Sonraki Hafta",
      NextYear: "Sonraki Yıl",
      OneMonthAgo: "Bir Ay Önce",
      OneWeekAgo: "Bir Hafta Önce",
      SixMonthsAgo: "Altı Ay Önce",
      Time: "Saat",
      CannotBeSelected: "Bu satır seçilemez.",
      ResetToDefault: "Varsayılan düzene sıfırla",
      CloseOtherTabs: "Diğer Sekmeleri Kapat",
      EmailValidation: "Geçerli bir e-posta adresi girin.",
      UrlValidation: "Geçerli bir URL girin",
      EndofResults: "Arama Sonuçları Sonu",
      More: "Daha Fazla...",
      RecordsPerPage: "Sayfa Başına Kayıt",
      Maximize: "maksimuma çıkarmak",
      Minimize: "azaltmak"
    }
  });
})(this);
